export default __webpack_public_path__ + "static/media/user-preferences-bg.b60667da.png";